import { AppSelectBox } from 'components';
import useClassSubject from 'hooks/API/GET/useClassSubject';
import { Fragment } from 'react';

function ClassSubjectsDropDown({
  enableAPI,
  value,
  handleChange,
  dependencies = {},
  fieldErrors = {},
}) {
  const { query = '' } = dependencies;
  const queryParams = `?mode=dropdown${query ? `&${query}` : ``}`;

  const { data, isLoading, isError } = useClassSubject({ enabled: enableAPI, queryParams });

  return (
    <AppSelectBox
      labelProps={{ label: 'Select subject' }}
      selectProps={{
        value,
        onChange: handleChange,
      }}
      fieldErrors={fieldErrors}
    >
      {isLoading ? (
        <option disabled value="">
          Loading...
        </option>
      ) : isError ? (
        <option disabled value="">
          Failed to load list
        </option>
      ) : (
        <Fragment>
          {data?.data?.length > 0 ? (
            <Fragment>
              <option value="">Choose</option>
              {data?.data?.map((option) => {
                return (
                  <option key={option._id} value={option._id}>
                    {option.name}
                  </option>
                );
              })}
            </Fragment>
          ) : (
            <option value="">No options found</option>
          )}
        </Fragment>
      )}
    </AppSelectBox>
  );
}

ClassSubjectsDropDown.defaultProps = {
  handleChange: () => {},
};

export default ClassSubjectsDropDown;
